export default "__VITE_ASSET__BebBJvCF__"